// import $ from 'jquery';// eslint-disable-line
import Vue from 'vue';
import App from './Template/App.vue';
import store from './Template/Store/store.js';

new Vue({
  store,
  render: h => h(App),// eslint-disable-line
}).$mount('#app');
